// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyA3-TXPbrEWqLy94EPzh2LSX1kuryldSeY",
    authDomain: "trainer-app-services.firebaseapp.com",
    projectId: "trainer-app-services",
    storageBucket: "trainer-app-services.appspot.com",
    messagingSenderId: "869346522288",
    appId: "1:869346522288:android:9a8458587ad6902ab4b775"
  },
  vapidKey: 'BIzvaDEFA6X9MXQMQLBBZ7WJ7pLO5m2pik3eVo3j9Lro5DhXAFZ8R8-7Lo8QEGPRCPL94fwal2hmqrWECcIKox0'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
